import { Button } from '@components/common';
import { toMaskedAddress } from '@utils';

interface WalletAddressProps {
  address?: string;
  onClick: () => void;
}

export const ConnectWalletButton = ({
  address,
  onClick,
}: WalletAddressProps) => {
  if (!address) {
    return <Button onClick={onClick}>{'Connect'}</Button>;
  }

  const maskedAddress = toMaskedAddress(address);

  return <Button onClick={onClick}>{maskedAddress}</Button>;
};
